import { Button, Spinner, ButtonProps, Box } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';

type SubmitButtonProps = Omit<ButtonProps, 'children'> & {
  loading: boolean;
  initText?: string;
  loadingText?: string;
  defaultType?: 'save' | 'update' | 'delete' | 'cancel' | 'search';
  children?: React.ReactNode; // sobrescreve como opcional
};

const SubmitButton = ({
  loading,
  initText,
  loadingText,
  defaultType = 'save',
  children,
  ...props
}: SubmitButtonProps) => {
  const { t } = useTranslation();

  const fallbackTexts = {
    save: { init: 'General.save', loading: 'General.saving' },
    update: { init: 'General.update', loading: 'General.updating' },
    delete: { init: 'General.delete', loading: 'General.deleting' },
    search: { init: 'General.search', loading: 'General.searching' },
    cancel: { init: 'General.cancel', loading: 'General.canceling' },
  };

  const texts = fallbackTexts[defaultType] ?? fallbackTexts.save;
  const displayText = loading
    ? t(loadingText || texts.loading)
    : t(initText || texts.init);

  return (
    <Button {...props}>
      {loading ? (
        <Box as="span" display="flex" alignItems="center" gap="2">
          <Spinner color="currentColor" size="small" />
          <Box as="span">{displayText}</Box>
        </Box>
      ) : children ? (
        children
      ) : (
        <Box as="span">{displayText}</Box>
      )}
    </Button>
  );
};

export default SubmitButton;
